var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-bihua",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 31.528,
    viewBox: "0 0 122 31.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "propal_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M0,37.745V16.16H11.729q9.891,0,9.891,5.562,0,3.363-3.916,4.6,4.823,1.414,4.829,5.137a5.166,5.166,0,0,1-2.618,4.689q-2.618,1.6-7.657,1.6ZM11.764,24.794a7.366,7.366,0,0,0,3.491-.64,2.1,2.1,0,0,0,1.117-1.961,1.9,1.9,0,0,0-1.164-1.833,9.169,9.169,0,0,0-3.747-.582h-6.4v5.015ZM11.9,34.1a9.123,9.123,0,0,0,4.073-.675,2.327,2.327,0,0,0,1.286-2.193,2.409,2.409,0,0,0-1.286-2.24,8.65,8.65,0,0,0-4.073-.721H5.1V34.1Z",
    transform: "translate(0 -6.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M46.83,37.745V16.16h5.411V37.745Z",
    transform: "translate(-19.584 -6.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M84.945,37.745V28.7H71.761v9.041H66.35V16.16h5.411V24.5H84.945V16.16H90.35V37.745Z",
    transform: "translate(-27.747 -6.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M135.626,16.16h5.388V28.675q0,4.835-2.909,7.226T129.2,38.286q-5.987,0-8.908-2.385t-2.909-7.226V16.16h5.411v12.8a5,5,0,0,0,1.553,4.073,9.739,9.739,0,0,0,9.734,0,5.016,5.016,0,0,0,1.559-4.073Z",
    transform: "translate(-49.087 -6.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M183.686,37.745l-2.4-4.9H169.112l-2.362,4.9h-5.58L172.224,16.16h6.121L189.4,37.745ZM175.2,20.361l-4.236,8.646h8.524Z",
    transform: "translate(-67.399 -6.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 23.645,
    height: 2.746,
    transform: "translate(68.281)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7ef15325981d35551e0cef6e8535bee0.svg";
export { ForwardRef as ReactComponent };